import src from "IMAGE";
export default { src, width: 1200, height: 268, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAANklEQVR42k3JQQ4AEAxEUfe/pISIVks5wWhjY/EWMz+xGoZTO5C5EZtkoXRBbowUx49cpRfDBbuhO9fsHTOnAAAAAElFTkSuQmCC"};
